import { render } from "./ImageImpulse.vue?vue&type=template&id=09d3ef28"
import script from "./ImageImpulse.vue?vue&type=script&lang=js"
export * from "./ImageImpulse.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__